<template>
  <app-industry-item-template :itemTitle="'Jyske Bank'" :routeName="'Contact'">

    <p><strong>Who is Visa & Jyske Bank?</strong></p>

    <p>
      Visa is the world’s largest payment network and Jyske Bank is a leading Danish financial institution.<br><br>

      <strong>The business objective:</strong><br><br>

      Create a significant and lasting customer preference for the Jyske Bank Visa Flex Card, being introduced in 
      the Danish market.
    </p>

    <img src="@/assets/images/cases/jyske-bank.jpg" alt="Jyske Bank Image">

    <br>
    <br>

    <p class="no-margin">
      <strong>How Visa & Jyske bank did it - with our help</strong><br><br>

      Using LoyalTfacts&reg; and our APIs, Jyske Bank build a super-smooth user experience in their market leading App, 
      enabling cardholders to opt in to earning significant rewards in one click. 
      Using LoyalTfacts&reg; APIs, we instantly opened a large merchant network in Denmark for Jyske Bank Visa cardholders - 
      providing merchant funded offers and driving spend and frequency.
      - <a href="https://www.jyskebank.dk/produkter/kort/visa-flex" target="_blank" rel="noopener">Check it out</a>
    </p>

  </app-industry-item-template>
</template>

<script>
  import AppIndustryItemTemplate from '@/components/layout/templates/content/AppContentTemplateIndustryItem';

  export default {
      name: 'JyskeBank',

      components: {
        AppIndustryItemTemplate,
      },
  }
</script>

<style scoped lang="scss">

</style>
